'use client'

import Markdown from 'markdown-to-jsx'
import Image from 'next/image'
import React from 'react'

import { getTranslate } from '../../utilities/i18n'
import BackButtonWithQueryForwarding from '../button/BackButtonQueryForwarding'
import ListHeaderVideo from './ListHeaderVideo'

type Props = {
  readonly topic: string
  readonly logo?: string
  readonly headerImage?: string
  readonly videoLink?: string
  readonly backButtonLink: string
  readonly isPublic?: boolean
}

const ListHeader: React.FC<Props> = ({ topic, logo, headerImage, videoLink, backButtonLink, isPublic }) => {
  const { t } = getTranslate()

  const onlyText = !headerImage && !videoLink

  return (
    <>
      <div className="px-3">
        {!isPublic && (
          <BackButtonWithQueryForwarding link={backButtonLink} text={t('component.button.back')} icon="back" />
        )}
        <div
          className={`${
            isPublic ? 'mx-auto max-w-[800px] bg-body-bg' : 'my-8 rounded-xl bg-white px-8'
          } ${onlyText ? 'text-center' : ''} py-8 big-tablet:flex`}
        >
          <div className={`flex w-full flex-col justify-center ${onlyText ? 'items-center' : 'items-start'} `}>
            {!isPublic && logo && (
              <img
                className="mb-2 h-[64px] w-[180px] rounded-xl object-cover big-tablet:mb-8 big-tablet:mr-8"
                alt={t(`component.premiumContent.${topic}.title`)}
                src={`/images/svg/premiumContent/content-${logo}-white-bg.svg`}
              />
            )}
            <h1 className={`w-full ${onlyText ? 'mb-6 text-4xl tablet:text-5xl' : 'h2 text-3xl'} text-petrol-500`}>
              {t(`component.premiumContent.${topic}.title`)}
            </h1>

            <div className={`mb-4 max-w-[800px] text-lg big-tablet:mb-0 ${onlyText ? '' : 'big-tablet:mr-8'}`}>
              <Markdown>
                {t(`component.premiumContent.${topic}.description`, null, {
                  fallback: `component.premiumContent.${topic}.subtitle`,
                })}
              </Markdown>
            </div>
          </div>
          {videoLink ? (
            <ListHeaderVideo videoLink={videoLink} />
          ) : headerImage ? (
            <Image
              alt={t(`component.premiumContent.${topic}.title`)}
              width="438"
              height="282"
              sizes="438px"
              className="rounded-xl"
              src={`/images/svg/premiumContent/header-${headerImage}.svg`}
            />
          ) : null}
        </div>
      </div>
    </>
  )
}

export default ListHeader
